import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './Select.scss';

export const Select = (props) => {
  const {
    className,
    id,
    label,
    options,
    required,
    onChange,
    disabled,
    startValue,
  } = props;

  const classes = classNames('lanl-select', className);

  return (
    <div className={classes}>
      {label && <label htmlFor={id}>{label}</label>}
      <select
        key={startValue?.value}
        name={id}
        id={id}
        defaultValue={startValue?.value ?? options[0]?.value}
        required={required}
        onChange={onChange}
        disabled={disabled}
      >
        {options.map(({ label, value }, index) => (
          <option key={index} value={value}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

Select.defaultProps = {
  options: [],
  required: false,
};

Select.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
  required: PropTypes.bool,
};

export default Select;
